// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export class BaseError extends Error {
  // biome-ignore lint/suspicious/noConfusingVoidType: <explanation>
  public readonly originalError: Error | undefined | void;
  // biome-ignore lint/suspicious/noConfusingVoidType: <explanation>
  public readonly errorCode: number | undefined | void;

  public constructor(message: string, originalError?: Error | undefined, errorCode?: number | undefined) {
    super(message);
    this.message = message;
    this.originalError = originalError;
    this.errorCode = errorCode;

    // biome-ignore lint/suspicious/noExplicitAny: <explanation>, no-proto
    (this as any).__proto__ = BaseError.prototype;
  }
}
